import { deleteData, getData, patchData, postData } from "../api/api";
import type { MailFilter } from "../types/mailFilter";
import { buildReadQueryString } from "../lib/api/readQuery";

const MAIL_FILTER_BASE_URL = "/mail-filter";

export const mailFilterService = {
  getMailFilters: async (
    page: number = 0,
    size: number = 50,
    search?: string,
    fields?: string | string[],
  ) => {
    return getData(
      `${MAIL_FILTER_BASE_URL}/read?${buildReadQueryString({
        page,
        size,
        sort: "createdDate,desc",
        search,
        fields,
      })}`,
    );
  },

  getMailFilter: async (id: string) => {
    return getData(`${MAIL_FILTER_BASE_URL}/read/${id}`);
  },

  createMailFilter: async (data: MailFilter) => {
    return postData(`${MAIL_FILTER_BASE_URL}/create`, data);
  },

  updateMailFilter: async (data: MailFilter) => {
    return patchData(`${MAIL_FILTER_BASE_URL}/update`, data);
  },

  deleteMailFilter: async (id: string) => {
    return deleteData(`${MAIL_FILTER_BASE_URL}/delete/${id}`);
  },
};

